import { de } from '@/i18n/de';
import { cn } from '@/shell/lib/cn';
import { ThemeToggle } from '@/shell/theme/theme-toggle';
import { InternalLink } from '@/shell/ui/internal-link';
import { MoreMenu } from './more-menu';
import { isActive, MAIN_NAV, MORE_NAV } from './nav';

const WORDMARK = 'text-lead font-bold tracking-tight text-ink';

/**
 * Obere Leiste (Desktop und Tablet): Wortmarke, Hauptnavigation, Umschalter hell/dunkel und „Mehr“. Aktives Ziel:
 * `aria-current="page"`, fette Schrift und 3 px Unterstrich in Lagune (nicht nur Farbe).
 */
export function TopBar({ pathname }: { pathname: string }) {
  return (
    <header className="sticky top-0 z-30 border-b border-line bg-surface-block">
      <div className="mx-auto flex min-h-16 max-w-[1200px] flex-wrap items-center gap-x-6 gap-y-1 px-4 lg:px-6">
        <InternalLink href="/" className={WORDMARK}>
          {de.app.name}
        </InternalLink>
        <nav aria-label={de.nav.label} className="flex flex-1 flex-wrap items-center gap-x-1">
          {MAIN_NAV.map((item) => {
            const active = isActive(pathname, item.href);
            return (
              <InternalLink
                key={item.id}
                href={item.href}
                current={active}
                className={cn(
                  'flex min-h-16 items-center border-b-[3px] px-2 text-body text-ink-muted hover:text-ink lg:px-3',
                  active ? 'border-accent font-bold text-ink' : 'border-transparent',
                )}
              >
                {item.label}
              </InternalLink>
            );
          })}
          <MoreMenu items={MORE_NAV} className="ml-auto" />
        </nav>
        <ThemeToggle />
      </div>
    </header>
  );
}

/** Schmale Kopfzeile auf dem Handy: Wortmarke und Umschalter (die Navigation sitzt unten). */
export function CompactHeader() {
  return (
    <header className="flex min-h-14 items-center justify-between border-b border-line bg-surface-block px-4">
      <InternalLink href="/" className={WORDMARK}>
        {de.app.name}
      </InternalLink>
      <ThemeToggle />
    </header>
  );
}
